import { computed, defineComponent, PropType } from 'vue';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default defineComponent({
  name: 'dl-json-viewer',
  components: { VueJsonPretty },
  props: {
    // paths greater than this depth will be collapsed
    pathDepth: { type: Number, default: 0, required: false },
    jsonData: {
      type: Object as PropType<Record<string, any>>,
      default: null,
      required: true
    }
  },
  setup(props) {
    const depth = computed((): number => {
      return props.pathDepth;
    });

    const data = computed((): Object => {
      return props.jsonData;
    });

    return { depth, data };
  }
});
